import { Interpolation } from '@emotion/css'
import { Theme } from 'src/theme/theme'

const styles = {
  flexColumn: {
    alignItems: 'center',
    justifyContent: 'center',
  } as Interpolation,
  flex: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 668px)': {
      marginBottom: 15,
    },
  },
  header: (theme: Theme) =>
    ({
      display: 'flex',
      padding: '15px 8px',
      borderBottom: `1px solid ${theme.colors.lightGrey}`,
      justifyContent: 'space-between',
      alignItems: 'center',
      '@media (max-width: 668px)': {
        flexDirection: 'column',
      },
    } as Interpolation),
  container: {
    height: '100%',
    width: '100%',
  } as Interpolation,
  contents: {
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
  amount: {
    fontSize: 48,
    fontWeight: 600,
  },
  type: (theme: Theme) => ({
    color: theme.colors.lightGrey,
    fontWeight: 650,
  }),
}

export default styles
